import React, { useContext, useEffect, useState } from "react"
import { CheckValidation } from "../../Components/Validations";
import { CamelCaseWithSpaces, GetAllGroups, LogInSchoolID, LogInUserID, formatDateToUsaMMDDYYYY, getAllUsers, transformNameOfCol, typewatch, origin, getTypeWatchDelay } from "../../JS/Common";
import AlertsComp from "../../Components/AlertsComp";
import { ApiGetCall, ApiGetCallAuthKey, ApiGetCDNData, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faVideo } from "@fortawesome/free-solid-svg-icons";
import Pagination from "react-js-pagination";
import CustomizationPopup from "../../Components/CustomizationPopup";
import HDrequestpopup from "../../Components/HDrequestpopup";
import { useNavigate } from "react-router-dom";
import CommentPopup from "./CommentPopup";
import VideoPopup from "./VideoPopup";
import HelpdeskCommentPopup from "../Helpdesk/HelpdeskCommentPopup";
import { UserContext } from "../../App";
import PageHead from "../../Components/PageHead";
import Tab from "../../Components/Tab";
import AlertPopup from "../../Components/AlertPopup";
import QuickAddTickets from "./QuickAddTickets";
import DownloadOpenTicketReport from "../Helpdesk/DownloadOpenTicketReport";
import ImagesPopup from "../../Components/ImagesPopup";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";
import { useStickyAction } from "../../Hooks";

export function TechnologySupportTicket() {
    const { staff_member, manager_user } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const navigate = useNavigate();
    const [Alerts, setAlerts] = useState("");
    const [SupportTickets, setSupportTickets] = useState([]);
    const [deletePopup, setdeletePopup] = useState(false);
    const [IsComment, setIsComment] = useState(false);
    const [IsCommentForHelpdesk, setIsCommentForHelpdesk] = useState(false);
    const [CommentData, setCommentData] = useState('');
    const [allData, setAllData] = useState({
        UpdateFlag: 1,
        Title: "",
        Description: "",
        Id: 0,
        fileName: "",
        OriginalImage: "",
        ShowUploadDiv: "",
        ShowOriginalImage: "d-none",
        Flag: 0,
        TicketId: "",
        TicketNum: '',
        Comment: "",
        AssigneeId: '',
        Documentt: null,
        Filename: "",
        StatusFlag: '',
        SortbyFlag: 'asc'
    });
    const [SupportTicketTabs, setSupportTicketTabs] = useState({
        OpenTicketTabs: "active",
        CloseTicketTabs: "",
        searchForOpen: '',
        searchForClose: '',
        PastTicketTabs: '',
        searchForPast: '',
    });
    const [AssigneeId, setAssigneeId] = useState([])
    const [AllGroups, setAllGroups] = useState([])
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [PreviewImg, SetPreviewImg] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = SupportTickets.length > 0;
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [columnNames, setColumnNames] = useState([]);
    const [PreviewVideo, SetPreviewVideo] = useState('')
    const [videoShow, setVideoShow] = useState(false);
    const [SortbyKey, setSortbyKey] = useState(null);
    const [PopupData, setPopupData] = useState('');
    const [isHDPopup, setisHDPopup] = useState(false);
    const [isQuickAddPopup, setisQuickAddPopup] = useState(false);
    const [ResolutionStatement, setResolutionStatement] = useState('');
    const [noteVisibility, setNoteVisibility] = useState({});
    const [TrackedTime, setTrackedTime] = useState('');
    const [helpdeskId, setHelpdeskId] = useState('');
    const [filterassignedid, setFilterassignedid] = useState(null);
    const [showImagesModal, setShowImagesModal] = useState({
        show: false,
        activeIndex: 0,
        zoomInOut: false,
    });
    const { UserData } = useContext(UserContext);
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const onlySchoolAdmin = hasRoleAccess(effectiveRole, RoleEnum.ONLY_SCHOOL_ADMIN);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    useEffect(() => {
        ApiGetHeaders(18, setColumnNames)
    }, []);
    useEffect(() => {
        if (SupportTicketTabs.OpenTicketTabs == 'active') {
            GetAllSupportTickets(1, SupportTicketTabs.searchForOpen ? SupportTicketTabs.searchForOpen : null, SortbyKey ? SortbyKey : null, false);
        } else if (SupportTicketTabs.CloseTicketTabs == 'active') {
            GetAllSupportTickets(2, SupportTicketTabs.searchForClose ? SupportTicketTabs.searchForClose : null, SortbyKey ? SortbyKey : null, false);
        } else {
            GetAllSupportTickets(3, SupportTicketTabs.searchForPast ? SupportTicketTabs.searchForPast : null, SortbyKey ? SortbyKey : null, false);
        }
        getAllUsers(setAssigneeId);
        GetAllGroups({ setLoading, setAllGroups })
    }, [currentPage, LimitForPagination, filterassignedid])

    async function GetAllSupportTickets(flag, searchstring, sortkey, toogleSort) {
        setNoteVisibility({});
        if (!searchstring) searchstring = null;
        if (filterassignedid == 0) setFilterassignedid(null);
        if (sortkey && toogleSort) allData.SortbyFlag = allData.SortbyFlag == "asc" ? "desc" : "asc";
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/support-tickets/all?search=${searchstring}&schoolId=${LogInSchoolID}&userId=${LogInUserID}&flag=${flag}&sortBy=${sortkey}&sortByOrder=${allData.SortbyFlag}&type=1&page=${currentPage}&limit=${LimitForPagination}&filter=${filterassignedid}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    if (responseRs.status == "success") {
                        setpageRangeCount(responseRs?.ticket_data?.total)
                        setSupportTickets(responseRs?.ticket_data?.data)
                    } else {
                        setSupportTickets([])
                    }
                }
            });
        }, getTypeWatchDelay(searchstring, 500));
    }
    async function ChangeStatus() {
        if (allData.StatusFlag == 1) {
            var isFormValid = CheckValidation({ formID: 'resolutionstatementdiv' });
            if (!isFormValid) return;
        }
        setLoading(true)
        var href = null;
        if (UserData.helpdeskUpdatedFlag != null) {
            href = '/helpdesk/change-status'
            var raw = JSON.stringify({
                hdRequestId: helpdeskId,
                flag: allData.StatusFlag,
                resolution: ResolutionStatement,
                trackedTime: TrackedTime
            });
        } else {
            href = '/support-tickets/change-status'
            var raw = JSON.stringify({
                ticketId: allData.TicketId,
                flag: allData.StatusFlag,
                resolution: ResolutionStatement,
                trackedTime: TrackedTime
            });
        }
        await ApiPostCall(href, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    const alertMessage = allData.StatusFlag == 1 ? "Ticket Close Successfully." : "Ticket Open Successfully.";
                    setAlerts(<AlertsComp show={true} variant="success" msg={alertMessage} />);

                    setTimeout(() => {
                        setdeletePopup(false);
                        const tabStatus = SupportTicketTabs.OpenTicketTabs == 'active' ? 1 :
                            SupportTicketTabs.CloseTicketTabs == 'active' ? 2 : 3;
                        GetAllSupportTickets(tabStatus, null, null, false);
                        setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }

                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function GetComment(ticketNum, ticketid) {
        setAllData({ ...allData, TicketId: ticketid, TicketNum: ticketNum, Filename: '', Description: '', Comment: '', Documentt: '' })
        setIsComment(true);
        setLoading(true);
        await ApiGetCallAuthKey(`/support-tickets/comments?ticketId=${ticketid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.status == "success") {
                    setCommentData(responseRs.support_ticket_details);
                }
            }
        });
    }

    function GenerateUrl(TicketNum, hdId, tickeetid) {
        var schoolnumber = StateData?.Schoolnumber;
        var path
        if (hdId != null) {
            path = `/helpdesk-ticket/${hdId}/${schoolnumber}/${TicketNum}`;
        } else {
            path = `/ticket/${tickeetid}/${schoolnumber}/${TicketNum}`;
        }
        var url = `${origin}${path}`;
        const newTab = window.open('', '_blank');
        newTab.location.href = url;
        newTab.focus();
    }
    async function UpdateLocation(supportTicketID, Assignedid, flag, hdrequestid) {
        setLoading(true);
        var href = null;
        if (UserData.helpdeskUpdatedFlag != null) {
            href = '/helpdesk/assign-ticket'
            var raw = JSON.stringify({
                schoolId: LogInSchoolID,
                staffId: Assignedid == 0 ? null : Assignedid,
                flag: flag, //1 group 2 user
                hdRequestId: hdrequestid
            });
        } else {
            href = '/support-tickets/assign-to-staff'
            var raw = JSON.stringify({
                schoolId: LogInSchoolID,
                supportTicketId: supportTicketID,
                staffId: Assignedid == 0 ? null : Assignedid,
            });
        }
        await ApiPostCall(href, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={"Assigned Successfully"} />);
                    const tabStatus = SupportTicketTabs.OpenTicketTabs == 'active' ? 1 :
                        SupportTicketTabs.CloseTicketTabs == 'active' ? 2 : 3;
                    GetAllSupportTickets(tabStatus, null, null, false);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                } else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    const handleSortClick = (item) => {
        if (item == 'StudentNum') {
            item = 'student_num'
        } else if (item == 'Subject') {
            item = 'title'
        } else if (item == 'ticketnum') {
            if (UserData.helpdeskUpdatedFlag) {
                item = SupportTicketTabs.PastTicketTabs == 'active'
                    ? 'support_ticket_num'
                    : 'request_num';
            } else {
                item = 'support_ticket_num';

            }
        }
        else {
            item = item.toLowerCase().split(' ').join('_');
        }
        if (item !== 0) {
            if (SupportTicketTabs.OpenTicketTabs == 'active') {
                GetAllSupportTickets(1, SupportTicketTabs.searchForOpen, item, true)
            } else if (SupportTicketTabs.CloseTicketTabs == 'active') {
                GetAllSupportTickets(2, SupportTicketTabs.searchForClose, item, true)
            } else {
                GetAllSupportTickets(3, SupportTicketTabs.searchForPast, item, true)
            }
            setSortbyKey(item)
        }
    };
    function GetCDNUrlForImage(finalpath) {
        ApiGetCDNData("/" + finalpath, StateData?.Schoolnumber).then((blob) => {
            try {
                const url = URL.createObjectURL(blob);
                setShowImagesModal({ ...showImagesModal, show: true, activeIndex: 0 })
                SetPreviewImg(url)
            } catch (err) {
                log.error(err);
            }
        });
    }
    function GetCDNUrlForVideo(finalpath) {
        ApiGetCDNData("/" + finalpath, StateData?.Schoolnumber).then((blob) => {
            try {
                const url = URL.createObjectURL(blob);
                setVideoShow(true);
                SetPreviewVideo(url);
            } catch (err) {
                log.error(err);
            }
        });
    }
    function renderContentForColumn(columnName, item) {
        var images = UserData.helpdeskUpdatedFlag ?
            SupportTicketTabs.PastTicketTabs == 'active' ?
                item.img != null ? (
                    <img src="/images/PicturePreview.svg"
                        className="boxshaowstyle cursor-pointer" height='25px'
                        onClick={(e) => { GetCDNUrlForImage(item.img); }} />
                ) : '-'
                :
                item.document ?
                    <img src="/images/PicturePreview.svg"
                        className="boxshaowstyle cursor-pointer" height='25px'
                        onClick={(e) => { GetCDNUrlForImage(item.document); }} />
                    : '-'
            : item.img != null ? (
                <img src="/images/PicturePreview.svg"
                    className="boxshaowstyle cursor-pointer" height='25px'
                    onClick={(e) => { GetCDNUrlForImage(item.img); }} />
            ) : '-';
        var videos = UserData.helpdeskUpdatedFlag ?
            SupportTicketTabs.PastTicketTabs == 'active' ?
                item.video_path != null ? (
                    <FontAwesomeIcon icon={faVideo} style={{ height: '18px' }}
                        title="Video Attachment" className="cursor-pointer"
                        onClick={(e) => { GetCDNUrlForVideo(item.video_path) }} />
                ) : '-'
                :
                item.video ?
                    <FontAwesomeIcon icon={faVideo} style={{ height: '18px' }}
                        title="Video Attachment" className="cursor-pointer"
                        onClick={(e) => { GetCDNUrlForVideo(item.video) }} />
                    : '-'
            : item.video_path != null ? (
                <FontAwesomeIcon icon={faVideo} style={{ height: '18px' }}
                    title="Video Attachment" className="cursor-pointer"
                    onClick={(e) => { GetCDNUrlForVideo(item.video_path) }} />
            ) : '-';
        const contentMap = {
            "Img": images,
            "Name": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.name || '-'}</div>,
            "Email": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.email || '-'}</div>,
            "Subject": <div className={`note-wrap ${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.title || '-'}</div>,
            "building": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.other_building_name ? item.other_building_name : item?.building_detail ? item?.building_detail?.name : item?.building?.name || "-"}</div>,
            "Description": <div className={`note-wrap ${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.description || '-'}</div>,
            "videoPath": videos,
            "Room": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.room_name ? item.room_name : item.room ? item?.room?.name : '-'}</div>,
            "Role":
                UserData.helpdeskUpdatedFlag != null ?
                    <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.requester_type == 1 ? manager_user : staff_member}</div>
                    :
                    <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.role == 1 ? manager_user : staff_member}</div>
            ,
            "StudentNum": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.student_num == 'null' || item.student_num == null || item.student_num == '' ? '-' : item.student_num}</div>,
            "created_at": <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{formatDateToUsaMMDDYYYY(item.created_at) || '-'}</div>
        };

        return contentMap[columnName] || null;
    }

    async function GetHelpdeskDataById(reuqestid) {
        setLoading(true);
        await ApiGetCallAuthKey(`/helpdesk?schoolId=${LogInSchoolID}&uuid=${reuqestid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setPopupData(responseRs);
                setisHDPopup(true);
            }
        });
    }
    function handleArrowClick(ticketId) {
        setNoteVisibility((prevState) => ({
            ...prevState,
            [ticketId]: !prevState[ticketId],
        }));
    }
    function handleSearchChange(e) {
        const { value } = e.target;
        const tabStatus = SupportTicketTabs.OpenTicketTabs == 'active' ? 1 :
            SupportTicketTabs.CloseTicketTabs == 'active' ? 2 : 3;

        setCurrentPage(1);
        GetAllSupportTickets(tabStatus, value, null, false);

        const tabKey = SupportTicketTabs.OpenTicketTabs == 'active' ? 'searchForOpen' :
            SupportTicketTabs.CloseTicketTabs == 'active' ? 'searchForClose' : 'searchForPast';

        setSupportTicketTabs({ ...SupportTicketTabs, [tabKey]: value });
    }
    const handleTabClick = (tabType) => {
        let tabStatus = 1;
        let newTabsState = { OpenTicketTabs: "", CloseTicketTabs: "", PastTicketTabs: "" };

        if (tabType == 'open') {
            tabStatus = 1;
            newTabsState.OpenTicketTabs = "active";
        } else if (tabType == 'close') {
            tabStatus = 2;
            newTabsState.CloseTicketTabs = "active";
        } else if (tabType == 'past') {
            tabStatus = 3;
            newTabsState.PastTicketTabs = "active";
        }

        GetAllSupportTickets(tabStatus, null, null, false);
        setSupportTicketTabs({ ...SupportTicketTabs, ...newTabsState, searchForOpen: '', searchForClose: '', searchForPast: '' });
        setCurrentPage(1);
    };
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={UserData.helpdeskUpdatedFlag != null ? 'Technology Help Desk Tickets' : 'Technology Support Tickets'} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className='row my-2 d-flex justify-content-between pe-0 align-items-center'>
                <div className='col-md-12 ps-0 text-center d-md-flex justify-content-end align-items-center'>
                    {UserData.helpdeskUpdatedFlag != null ?
                        <div className="pe-3">{SupportTicketTabs.OpenTicketTabs == 'active' || SupportTicketTabs.CloseTicketTabs == 'active' ? '*Help Desk Tickets' : '*Support Tickets'}</div>
                        :
                        <div className="pe-3">*Support Tickets</div>
                    }
                    <div className="font-14 pe-3" style={{ color: 'black', cursor: 'pointer' }} >
                        {onlySchoolAdmin && (
                            UserData.helpdeskUpdatedFlag != null ?
                                <label className="cursor-pointer">{SupportTicketTabs.OpenTicketTabs == 'active' || SupportTicketTabs.CloseTicketTabs == 'active' ? <u onClick={(e) => navigate("/helpdesk-ticket-assignments")}> Ticket Assignments</u> : <u onClick={(e) => navigate("/ticket-assignments")}> Ticket Assignments</u>}</label>
                                :
                                <u className="cursor-pointer" onClick={(e) => navigate("/ticket-assignments")}> Ticket Assignments</u>

                        )}
                    </div>
                    <DownloadOpenTicketReport setAlerts={setAlerts} />
                    {UserData.helpdeskUpdatedFlag != null && (
                        <label className='BorderBtn text-center' title="Quick Add" onClick={(e) => setisQuickAddPopup(true)}> Quick Add
                            <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                        </label>
                    )}
                </div>
            </div>
            <div className="GridBox mt-2 p-3">
                <div className="row align-items-center mb-3">
                    <div className="col-md-9 px-0">
                        <ul className="nav nav-tabs px-3">
                            <Tab isActive={SupportTicketTabs.OpenTicketTabs == 'active'}
                                label="Open Tickets" onClick={() => handleTabClick('open')} col={'col-md-3'} />
                            <Tab isActive={SupportTicketTabs.CloseTicketTabs == 'active'}
                                label="Closed Tickets" onClick={() => handleTabClick('close')} col={'col-md-3'} />
                            {UserData.helpdeskUpdatedFlag != null &&
                                <Tab isActive={SupportTicketTabs.PastTicketTabs == 'active'}
                                    label="Old Tickets" onClick={() => handleTabClick('past')} col={'col-md-3'} />}
                        </ul>
                    </div>
                    <div className="col-md-3 text-end px-0">
                        <select className="mb-1 px-0" onChange={(e) => {
                            setFilterassignedid(e.target.value);
                        }}>
                            <option value="0">Filter by Assigned To</option>
                            {AssigneeId.map((item1, j) => (
                                <option value={item1.id} key={j} data-type="AssigneeId">
                                    {item1.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="greyBox helpdeskticket p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table mb-0">
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='fw-600 cursor-pointer' title="Sort by Ticket #" onClick={(e) => handleSortClick('ticketnum')}>Ticket #
                                        <img src="/images/sortbynew.svg" alt={`Sort by Ticket #`} className="img-fluid ps-2 sortbyClass" />
                                    </th>
                                    {columnNames?.map((item) => {
                                        let columnName = item.replace(/_/g, ' ');
                                        const transformedName = columnName == "StudentNum" ? "User ID" : transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            item != "videoPath" && item != 'Img' && item != "Room" && item != "building" ?
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => handleSortClick(item)}>
                                                    {CamelCaseWithSpaces(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                </th>
                                                :
                                                <th key={item} scope="col" className='fw-600'>
                                                    {CamelCaseWithSpaces(transformedName)}
                                                </th>
                                        );
                                    })}
                                    {SupportTicketTabs.OpenTicketTabs == 'active' && (
                                        <th scope="col" className='cursor-pointer fw-600'>Assigned To </th>)}
                                    {SupportTicketTabs.PastTicketTabs == 'active' && (
                                        <>
                                            <th scope="col" className='cursor-pointer fw-600'>Status </th>
                                            <th scope="col" className='cursor-pointer fw-600'>Assigned To</th>
                                        </>
                                    )}
                                    <th scope="col" className={`cursor-pointer fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                        Action
                                        <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2 pe-5"
                                            title='Customize Headers' style={{ height: '25px' }}
                                            onClick={(e) => setCustomizationModal(true)} />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {SupportTickets.length != 0 ? (
                                    SupportTickets.map((item, i) => {
                                        const isNoteVisible = noteVisibility[item.id];
                                        var returData = (
                                            <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                                <td className={`py-12`} >
                                                    <div className={`${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item.support_ticket_num}</div></td>
                                                {columnNames?.map(header => (
                                                    <td className={`py-12`} key={header}>  {renderContentForColumn(header, item)} </td>
                                                ))}
                                                {SupportTicketTabs.OpenTicketTabs == 'active' && (
                                                    item.hd_request_id ?
                                                        <td className='col-md-3 hoverable-text' onMouseEnter={(e) => { setIsDropdownOpen(i); setAllData({ ...allData, AssigneeId: item.assigned_to_id }) }} onMouseLeave={() => setIsDropdownOpen(null)}>
                                                            {item.assigned_flag == 2 ?
                                                                <>
                                                                    {isDropdownOpen === i ? (
                                                                        <select className="mb-1 px-0" defaultValue={item.assigned_to_id} onChange={(e) => {
                                                                            const selectedValue = e.target.value;
                                                                            const selectedOption = e.target.options[e.target.selectedIndex];
                                                                            const flag = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                                                                            setAllData({ ...allData, AssigneeId: selectedValue });
                                                                            UpdateLocation(item.id, selectedValue, flag, item.hd_request_id);
                                                                        }}>
                                                                            <option value="0">Select</option>
                                                                            {AssigneeId.map((item1, j) => (
                                                                                <option value={item1.id} key={j} data-type="AssigneeId" defaultValue={item1.id == item.assigned_to_id} >
                                                                                    {item1.name}
                                                                                </option>
                                                                            ))}
                                                                            {AllGroups.map((item2, k) => (
                                                                                <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups" >
                                                                                    {item2.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : (
                                                                        <div className={`py-2 ${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item?.assigned_user_flag == 1 ? item?.user_group?.name : item?.user?.first_name + ' ' + item?.user?.last_name}</div>
                                                                    )}
                                                                </>
                                                                : item.assigned_flag == 1 ?
                                                                    <>
                                                                        {isDropdownOpen === i ? (
                                                                            <select className="mb-1 px-0" defaultValue={item.assigned_to_id} onChange={(e) => {
                                                                                const selectedValue = e.target.value;
                                                                                const selectedOption = e.target.options[e.target.selectedIndex];
                                                                                const flag = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                                                                                setAllData({ ...allData, AssigneeId: selectedValue });
                                                                                UpdateLocation(item.id, selectedValue, flag, item.hd_request_id);
                                                                            }}>
                                                                                <option value="0">Select</option>
                                                                                {AssigneeId.map((item1, j) => (
                                                                                    <option value={item1.id} key={j} data-type="AssigneeId">
                                                                                        {item1.name}
                                                                                    </option>
                                                                                ))}
                                                                                {AllGroups.map((item2, k) => (
                                                                                    <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups" defaultValue={item2.id == item.assigned_to_id}>
                                                                                        {item2.name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            <div className={`py-2 ${(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) && 'helpdesk-highlight-part'}`}>{item?.user_group?.name}</div>
                                                                        )}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {isDropdownOpen === i ? (
                                                                            <select className="mb-1 px-0" onChange={(e) => {
                                                                                setAllData({ ...allData, AssigneeId: e.target.value });
                                                                                const selectedOption = e.target.options[e.target.selectedIndex];
                                                                                const source = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                                                                                UpdateLocation(item.id, e.target.value, source, item.hd_request_id);
                                                                            }}>
                                                                                <option value="0">Select</option>
                                                                                {AssigneeId.map((item1, j) => (
                                                                                    <option value={item1.id} key={j} data-type="AssigneeId">
                                                                                        {item1.name}
                                                                                    </option>
                                                                                ))}
                                                                                {AllGroups.map((item2, k) => (
                                                                                    <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups">
                                                                                        {item2.name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) : (
                                                                            <div className="py-2">-</div>
                                                                        )}
                                                                    </>
                                                            }
                                                        </td>
                                                        :
                                                        <td className=' col-md-3 hoverable-text' onMouseEnter={() => { setIsDropdownOpen(i); setAllData({ ...allData, AssigneeId: item.assigned_to_id }) }} onMouseLeave={() => setIsDropdownOpen(null)}>
                                                            {isDropdownOpen === i ?
                                                                <select className="mb-1 px-0" defaultValue={allData.AssigneeId} onChange={(e) => { setAllData({ ...allData, AssigneeId: e.target.value }); UpdateLocation(item.id, e.target.value, 2, item.hd_request_id); }}  >
                                                                    <option value="0">Select</option>
                                                                    {AssigneeId.map((item1, j) => (
                                                                        <option value={item1.id} key={j} defaultValue={item1.id === item.name} >
                                                                            {item1.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                : item.user == null ?
                                                                    (<>-</>)
                                                                    :
                                                                    (<div className="py-2">{item.user.first_name}&nbsp;{item.user.last_name}</div>)
                                                            }
                                                        </td>
                                                )
                                                }
                                                {SupportTicketTabs.PastTicketTabs == 'active' && (
                                                    <>
                                                        <td className="py-12" > <label style={{ color: item.status == 1 ? 'green' : 'red' }}> {item.status == 1 ? 'Open' : 'Closed'} </label></td>
                                                        <td className="py-12" > {item.user ? (item.user.first_name + ' ' + item.user.last_name) : ('-')} </td>
                                                    </>
                                                )}
                                                <td className={`d-flex ${isOverflowing ? 'sticky-action' : ''}`}>
                                                    <img src="/images/previewpdficon.svg" className="cursor-pointer px-1" title={item.hd_request_id != null ? 'Preview Help Desk Tickets' : 'Preview Support Tickets'} titleid={item.id} onClick={(e) => GenerateUrl(item.support_ticket_num, item.hd_request_id, item.id)} height='18px' />
                                                    {item.hd_request_id && (
                                                        <img src="/images/InfoIcon.svg" className="cursor-pointer px-1" title="Preview Help Desk Request" titleid={item.id} onClick={(e) => GetHelpdeskDataById(item.hd_request_id)} height='18px' />
                                                    )}
                                                    {(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) || onlySchoolAdmin ?
                                                        SupportTicketTabs.OpenTicketTabs == 'active' ?
                                                            item.hd_request_id ?
                                                                <img src="/images/TransactionIcon.svg" className="px-1 cursor-pointer" title="Mark as closed" titleid={item.id} onClick={(e) => { setdeletePopup(true); setAllData({ ...allData, TicketId: item.id, StatusFlag: 1 }); setHelpdeskId(item.hd_request_id) }} height='18px' />
                                                                :
                                                                <img src="/images/TransactionIcon.svg" className="px-1 cursor-pointer" title="Mark as closed" titleid={item.id} onClick={(e) => { setdeletePopup(true); setAllData({ ...allData, TicketId: item.id, StatusFlag: 1 }) }} height='18px' />
                                                            : SupportTicketTabs.CloseTicketTabs == 'active' ?
                                                                item.hd_request_id ?
                                                                    <img src="/images/TransactionIcon.svg" className="px-1 cursor-pointer" title="Mark as Open" titleid={item.id} onClick={(e) => { setdeletePopup(true); setAllData({ ...allData, TicketId: item.id, StatusFlag: 2 }); setHelpdeskId(item.hd_request_id) }} height='18px' />
                                                                    :
                                                                    <img src="/images/TransactionIcon.svg" className="px-1 cursor-pointer" title="Mark as Open" titleid={item.id} onClick={(e) => { setdeletePopup(true); setAllData({ ...allData, TicketId: item.id, StatusFlag: 2 }) }} height='18px' />
                                                                : <></>
                                                        : <></>
                                                    }
                                                    {(item.assigned_user_flag == 1 || item.assigned_user_flag == 2) || onlySchoolAdmin ?
                                                        SupportTicketTabs.OpenTicketTabs == 'active' ? (
                                                            item.hd_request_id ? (
                                                                <label title="Comment">
                                                                    <FontAwesomeIcon icon={faComment} style={{ color: "black", height: "18px" }} className='cursor-pointer px-1' onClick={(e) => { setHelpdeskId(item.hd_request_id); setIsCommentForHelpdesk(true); }} title="Comment" />
                                                                </label>
                                                            ) : (
                                                                <label title="Comment">
                                                                    <FontAwesomeIcon icon={faComment} style={{ color: "black", height: "18px" }} className='cursor-pointer px-1' onClick={(e) => { GetComment(item.support_ticket_num, item.id); }} title="Comment" />
                                                                </label>
                                                            )
                                                        ) : SupportTicketTabs.PastTicketTabs == 'active' ? (
                                                            item.status == 1 ?
                                                                <label title="Comment">
                                                                    <FontAwesomeIcon icon={faComment} style={{ color: "black", height: "18px" }} className='cursor-pointer px-1' onClick={(e) => { GetComment(item.support_ticket_num, item.id); }} title="Comment" />
                                                                </label>
                                                                : <></>
                                                        ) : (<></>)
                                                        :
                                                        <></>
                                                    }
                                                    {item.status == 2 && (
                                                        <>
                                                            <img src="/images/DownRoundArrow.svg" title="Show Resolution Statement" className={`cursor-pointer px-1 img-fluid ${isNoteVisible ? "d-none" : ""}`} onClick={() => handleArrowClick(item.id)} height='18px' />
                                                            <img src="/images/UpRoundArrow.svg" title="Hide Resolution Statement" className={`img-fluid px-1 cursor-pointer ${isNoteVisible ? "" : "d-none"}`} onClick={() => handleArrowClick(item.id)} height='18px' />
                                                        </>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                        if (isNoteVisible) {
                                            returData = (
                                                <>
                                                    {returData}
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            <b className="font-13 pe-3"> Resolution Statement:</b>
                                                            <div style={{ display: "inline" }}> {item.resolution || '-'} </div>
                                                        </td>
                                                    </tr>
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            <b className="font-13 pe-3"> Open Date:</b>
                                                            <div style={{ display: "inline" }}> {item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-'} </div>
                                                        </td>
                                                    </tr>
                                                    <tr className={`col-12  px-5`}>
                                                        <td colSpan={18}>
                                                            <b className="font-13 pe-3"> Completion Time:</b>
                                                            <div style={{ display: "inline" }}> {item.completion_time ? item.completion_time + ` hours` : '-'} </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                        return returData;
                                    }))
                                    :
                                    <tr className="text-center">
                                        <td colSpan={15}>No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}
            </div >
            {IsComment &&
                <CommentPopup CommentData={CommentData} IsComment={IsComment} setIsComment={(e) => setIsComment(false)}
                    setAllData={setAllData} allData={allData} setLoading={setLoading}
                    GetAllSupportTickets={(e) => GetAllSupportTickets(SupportTicketTabs.OpenTicketTabs == 'active' ? 1 : SupportTicketTabs.CloseTicketTabs == 'active' ? 2 : 3, null, null, false)} setAlerts={setAlerts} />}

            {IsCommentForHelpdesk &&
                <HelpdeskCommentPopup IsComment={IsCommentForHelpdesk} setIsComment={(e) => setIsCommentForHelpdesk(false)}
                    setAllData={setAllData} allData={allData} setLoading={setLoading}
                    GetAllSupportTickets={(e) => GetAllSupportTickets(SupportTicketTabs.OpenTicketTabs == 'active' ? 1 : SupportTicketTabs.CloseTicketTabs == 'active' ? 2 : 3, null, null, false)} setAlerts={setAlerts} helpdeskId={helpdeskId} />}

            <AlertPopup isshow={deletePopup} img={allData.StatusFlag == 1 ? '/images/redInfo.svg' : '/images/greenInfo.svg'}
                headingtext={allData.StatusFlag == 1 ? 'Are you sure want to close ticket?' : 'Are you sure want to Open ticket?'}
                text={allData.StatusFlag == 1 && (
                    <div className="col-12 parent pt-2 px-4" id="resolutionstatementdiv">
                        <div className="col-12">
                            <textarea type="textarea" rows={2} autoComplete="off" required name="resolution" className="form-control" onChange={(e) => setResolutionStatement(e.target.value)} />
                            <div className='FormLabel'>What did you do to resolve the issue?<label className='redText'>*</label></div>
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                        <div className="col-12 pt-4">
                            <input type="number" className="form-control" autoComplete='off'
                                name="timetrack" min={0} max={999}
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    let value = parseInt(e.target.value, 10);
                                    if (isNaN(value)) value = 0;
                                    value = Math.max(0, Math.min(999, value));
                                    setTrackedTime(value);
                                }}
                                required />
                            <div className='FormLabel'>How many hours did you spend to resolve this ticket?<label className='redText'>*</label></div>
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                )}
                cancelcall={(e) => { setResolutionStatement(""); setdeletePopup(false); setAllData({ ...allData, TicketId: "" }) }}
                canceltext={"Cancel"} successtext={"Yes"} successcall={(e) => ChangeStatus(e)} btntype={allData.StatusFlag == 1 ? 'deleteBtn' : 'SaveBtn'} />
            {videoShow && <VideoPopup videoShow={videoShow} setVideoShow={setVideoShow} PreviewVideo={PreviewVideo} />}
            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={UserData.helpdeskUpdatedFlag != null ? 'Technology Help Desk Tickets' : 'Technology Support Tickets'} GetCall={() => ApiGetHeaders(18, setColumnNames)} />}
            {isHDPopup && <HDrequestpopup isShow={isHDPopup} closepopup={(e) => setisHDPopup(false)} PopupData={PopupData} />}
            {isQuickAddPopup && <QuickAddTickets isShow={isQuickAddPopup} type={1}
                closepopup={(e) => setisQuickAddPopup(false)} setLoading={setLoading}
                setAlerts={setAlerts} getcall={(e) => GetAllSupportTickets(1, null, null, false)} />}

            <ImagesPopup
                AllImages={[PreviewImg]}
                isShow={showImagesModal.show}
                closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false })}
                title={"Preview Images"}
                size={"xl"}
                activeIndex={showImagesModal.activeIndex}
                handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
                zoomInOut={showImagesModal.zoomInOut}
                handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
            />
        </React.Fragment>
    )
}
